import { SERVER } from "../constants";
import { MAP_URL } from "../constants/urls";
import { HttpClient, SaveImage, SaveFile } from "../utils/requests";
import { fixUpdateInsertPaybillId } from "../panels/hr/insertPaybill/insertPaybillMapper";
import { fixUpdatePaybillsId } from "../panels/hr/paybills/paybillsMapper";
import { fixUpdateRequestId } from "../panels/hr/requests/requestsMapper";

export async function update(resource, params) {
  if (params?.data?.pictures) {
    await SaveImage(resource, params);
  }
  if (params?.data?.attachfile) {
    await SaveFile(resource, params);
  }
  let url = `${SERVER}/${MAP_URL[resource]}`;
  if (['adminUsers', 'config', 'user'].includes(resource)) {
    url = url + `/${params.id}`;
  }
  if (resource === 'productCategory') {
    let x = { ...params.data, categoryId: params.data.objectId };
    params.data = x;
  }
  return HttpClient(url, {
    method: "PUT",
    body: JSON.stringify(params.data),
  }).then(({ json }) => {
    if (resource === 'insertPaybill') {
      return fixUpdateInsertPaybillId(json);
    } else if (resource === 'paybills') {
      return fixUpdatePaybillsId(json);
    } else if (resource === 'request') {
      return fixUpdateRequestId(json);
    }

    return {
      data: { ...json, id: json.phoneNumber },
    };
  }
  );
}